// extracted by mini-css-extract-plugin
export default {"slide":"Slide__slide--28b","wc":"Slide__wc--1XS","image":"Slide__image--2I1","link":"Slide__link--1uo"};